import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import API from "../Network/API";

export default function AlarmAcknowledgmentViewModal({ isOpen, onClose, alarm, type }) {
    const [loading, setLoading] = useState(false);
    const [details, setDetails] = useState(null);
    const [acknowledgments, setAcknowledgments] = useState([]);

    useEffect(() => {
        if (!isOpen || !alarm?.id) {
            return;
        }

        setLoading(true);
        setDetails(null);
        setAcknowledgments([]);

        API.get(`/v1/oauth/acknowledgments/${alarm.id}/view`, {
            params: { alarm_type: type },
        })
            .then((response) => {
                setDetails(response.data.data.alarm);
                setAcknowledgments(response.data.data.acknowledgments || []);
            })
            .catch((error) => {
                toast.error(error?.response?.data?.message || "Failed to load acknowledgment history");
            })
            .finally(() => {
                setLoading(false);
            });
    }, [isOpen, alarm?.id, type]);

    const alarmData = details || alarm;

    return (
        <Modal
            isOpen={isOpen}
            toggle={onClose}
            size="lg"
            className="modal-dialog-scrollable popup-max-height"
            backdrop="static"
        >
            <ModalHeader toggle={onClose}>
                Alarm Details ({alarmData?.site_id})
            </ModalHeader>
            <ModalBody className="bg-light">
                {loading ? (
                    <div className="text-center py-4">
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    </div>
                ) : (
                    <>
                        <div className="bg-white rounded p-3 mb-3">
                            <div className="row g-2">
                                <div className="col-md-6">
                                    <small className="text-muted d-block">Site ID</small>
                                    <span className="fw-semibold">{alarmData?.site_id}</span>
                                </div>
                                <div className="col-md-6">
                                    <small className="text-muted d-block">Tenant</small>
                                    <span>{alarmData?.tenant_name}</span>
                                </div>
                                <div className="col-md-6">
                                    <small className="text-muted d-block">Alarm Name</small>
                                    <span>{alarmData?.name}</span>
                                </div>
                                <div className="col-md-6">
                                    <small className="text-muted d-block">Alarm Time</small>
                                    <span>{alarmData?.alarm_start}</span>
                                </div>
                                <div className="col-md-6">
                                    <small className="text-muted d-block">Elapsed Time</small>
                                    <span>{alarmData?.total_elaspsed || "-"}</span>
                                </div>
                                <div className="col-md-6">
                                    <small className="text-muted d-block">Status</small>
                                    <span className={`badge ${alarmData?.alarm_end ? "bg-secondary" : "bg-danger"}`}>
                                        {alarmData?.alarm_end ? "Cleared" : "Active"}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="bg-white rounded p-3">
                            <h6 className="mb-3">Acknowledgment History</h6>
                            {acknowledgments.length === 0 ? (
                                <p className="text-muted mb-0 text-center">No acknowledgment history found</p>
                            ) : (
                                <div className="table-responsive">
                                    <table className="table table-sm table-bordered mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th>#</th>
                                                <th>Remark</th>
                                                <th>User</th>
                                                <th>Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {acknowledgments.map((item, index) => (
                                                <tr key={item.id}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.remark}</td>
                                                    <td>{item.created_by}</td>
                                                    <td>{item.created_at}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </ModalBody>
        </Modal>
    );
}
